import { FilterKey } from '../types';

export interface FilterConfig {
  placeholder: string;
  buttonText: string;
}

export const filterConfigs: Record<FilterKey, FilterConfig> = {
  location: {
    placeholder: 'Enter location',
    buttonText: 'Update'
  },
  years_of_experience: {
    placeholder: 'Enter years of experience',
    buttonText: 'Add'
  },
  job_titles: {
    placeholder: 'Enter job title',
    buttonText: 'Add'
  },
  industries: {
    placeholder: 'Enter industry',
    buttonText: 'Add'
  },
  skills: {
    placeholder: 'Enter skill',
    buttonText: 'Add'
  }
};

export const yearsOfExperienceOptions = ['1', '2', '3', '4', '5+'];
